import axios from '@/plugins/axios';

const MENCO_CMS_URL = process.env.VUE_APP_MENCO_CMS_URL;


export function getGpWechatPosts(params) {
	return axios({
		url: `${MENCO_CMS_URL}/wechat-oa-posts`,
		method: 'get',
        params
	})
}

export function countGpWechatPosts() {
	return axios({
		url: `${MENCO_CMS_URL}/wechat-oa-posts/count`,
		method: 'get',
	})
}